<template lang="pug">
  .d-flex.align-center.gap-12.ga-3.text-center
    v-divider
    slot
      p.opacity-70.pb-1 {{ text }}
    v-divider
</template>

<script>

export default {
  props: {
    text: { type: String, default: '' },
  },
  data() {
    return {};
  },
};
</script>
